import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class DeleteEmailTemplateRPC implements
  LeoRPC<DeleteEmailTemplateRPC.Request, DeleteEmailTemplateRPC.Response, DeleteEmailTemplateRPC.Errors.Errors>
{
  abstract execute(
    request: DeleteEmailTemplateRPC.Request
  ): Promise<LeoRPCResult<DeleteEmailTemplateRPC.Response, DeleteEmailTemplateRPC.Errors.Errors>>;
}

export namespace DeleteEmailTemplateRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    templateId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isDeleteEmailTemplateRPCRequest: boolean = true;
  
    readonly templateId: LeoUUID;
  
  
    constructor(
    templateId: LeoUUID
    ) {
      this.templateId = templateId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const templateId = getLeoUuid(dto, "templateId", InvalidRequestTemplateIdError);
      return new Request(
        templateId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          templateId: this.templateId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `DeleteEmailTemplateRPC(templateId='${this.templateId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `DeleteEmailTemplateRPC.Response()`;
  };

  export enum RPCError {
    InvalidTemplateId = "INVALID_TEMPLATE_ID"
  }

  export namespace Errors {
    
    export interface InvalidTemplateIdDTO {
      code: string;
    }
    
    export class InvalidTemplateId extends LeoRPCError<RPCError> {
      readonly isInvalidTemplateId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidTemplateId;
        super(code);
      }
    
    
      toDTO(): InvalidTemplateIdDTO {
        const dto: InvalidTemplateIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidTemplateId.prototype.toString = function toString(): string {
      return `DeleteEmailTemplateRPC.INVALID_TEMPLATE_ID()`;
    };
    

    export type Errors = InvalidTemplateId;
    export type ErrorsDTO = InvalidTemplateIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidTemplateId:
          return new InvalidTemplateId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestTemplateIdError extends DeleteEmailTemplateRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestTemplateIdError";
  }
}


export class InvalidResponseInvalidTemplateIdError extends DeleteEmailTemplateRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidTemplateIdError";
  }
}

